export default __webpack_public_path__ + "static/media/barChart.be4a9d46.png";